import React, { useEffect, useState } from 'react';
import './TutorsPage.scss';
import { getTutors, getTutorByUser, deleteTutor } from '../../data/api';
import { Autocomplete, TextField, Chip, Skeleton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import { Bounce, ToastContainer, toast } from 'react-toastify';

const MODALITY_LABEL = {
  presencial: 'Presencial',
  virtual: 'Virtual',
  ambas: 'Presencial y virtual',
};

const MODALITY_COLOR = {
  presencial: '#219653',
  virtual: '#086788',
  ambas: '#ED4C5C',
};

export const TutorsPage = ({ toggleAddTutor }) => {
  const [tutors, setTutors] = useState(null);
  const [filtered, setFiltered] = useState(null);
  const [allSubjects, setAllSubjects] = useState([]);
  const [filterSubjects, setFilterSubjects] = useState([]);
  const [myTutor, setMyTutor] = useState(undefined);
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchTutors = async () => {
      const resp = await getTutors();
      if (resp.status === 'success') {
        setTutors(resp.tutors);
        setFiltered(resp.tutors);
      } else {
        setTutors([]);
        setFiltered([]);
      }
    };
    const fetchMyTutor = async () => {
      const resp = await getTutorByUser(userId);
      setMyTutor(resp.tutor || null);
    };
    fetchTutors();
    fetchMyTutor();

    const content = require('../../data/horarios.json');
    const unique = [...new Set(content.map(item => item.subject))].sort();
    setAllSubjects(unique);
  }, []);

  useEffect(() => {
    if (!tutors) return;
    if (filterSubjects.length === 0) {
      setFiltered(tutors);
    } else {
      setFiltered(tutors.filter(t =>
        filterSubjects.some(sub => t.subjects.includes(sub))
      ));
    }
  }, [filterSubjects, tutors]);

  const handleDelete = async () => {
    const resp = await deleteTutor(userId);
    if (resp.status === 'success') {
      toast.success('Perfil eliminado', { position: 'bottom-right', autoClose: 3000, theme: 'dark', transition: Bounce });
      setTimeout(() => window.location.reload(), 1000);
    } else {
      toast.error('Error al eliminar el perfil', { position: 'bottom-right', autoClose: 4000, theme: 'dark', transition: Bounce });
    }
  };

  return (
    <div className='tutors-page'>
      <div className='tutors-top'>
        <div className='tutors-top-left'>
          <Autocomplete
            multiple
            options={allSubjects}
            value={filterSubjects}
            onChange={(e, val) => setFilterSubjects(val)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip key={option} label={option} size="small" {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} label="Filtrar por materia" size="small" />
            )}
            sx={{ minWidth: 280, maxWidth: 500 }}
          />
        </div>
        <div className='tutors-top-right'>
          {myTutor ? (
            <>
              <button className='btn-edit-tutor' onClick={toggleAddTutor}>
                <EditIcon fontSize="small" /> Editar mi perfil
              </button>
              <button className='btn-delete-tutor' onClick={handleDelete}>
                <DeleteIcon fontSize="small" /> Eliminar
              </button>
            </>
          ) : (
            <button className='btn-add-tutor' onClick={toggleAddTutor}>
              + Ofrecer mis servicios
            </button>
          )}
        </div>
      </div>

      <div className='tutors-grid'>
        {filtered === null ? (
          Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={180} style={{ borderRadius: 10 }} />
          ))
        ) : filtered.length === 0 ? (
          <p className='no-tutors'>No hay tutores disponibles{filterSubjects.length > 0 ? ' para esas materias' : ''}.</p>
        ) : (
          filtered.map(tutor => (
            <div key={tutor._id} className={`tutor-card ${tutor.user === userId ? 'own-card' : ''}`}>
              <div className='tutor-card-header'>
                <div className='tutor-name-row'>
                  <PersonIcon className='tutor-person-icon' />
                  <p className='tutor-name'>{tutor.name}</p>
                </div>
                <span
                  className='tutor-modality'
                  style={{ backgroundColor: MODALITY_COLOR[tutor.modality] }}
                >
                  {MODALITY_LABEL[tutor.modality]}
                </span>
              </div>

              <div className='tutor-subjects'>
                {tutor.subjects.map(sub => (
                  <Chip key={sub} label={sub} size="small" className='subject-chip' />
                ))}
              </div>

              {tutor.description && (
                <p className='tutor-description'>"{tutor.description}"</p>
              )}

              <div className='tutor-card-footer'>
                {tutor.pricePerHour ? (
                  <p className='tutor-price'>${tutor.pricePerHour}/hora</p>
                ) : (
                  <p className='tutor-price-free'>Precio a convenir</p>
                )}
                <a
                  className='btn-whatsapp'
                  href={`https://wa.me/${tutor.whatsapp.replace(/\D/g, '')}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <WhatsAppIcon fontSize="small" /> Contactar
                </a>
              </div>
            </div>
          ))
        )}
      </div>
      <ToastContainer />
    </div>
  );
};
